if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
      }

      connectedCallback() {
        this.button = this.querySelector(`#StickyATC-${this.sectionId}`);
        this.priceWrapper = this.querySelector(`#StickyPrice-${this.sectionId}`);
        this.textEl = this.querySelector(`#StickyATCText-${this.sectionId}`);

        this.realForm = document.querySelector(`#product-form-${this.sectionId}`);
        this.realButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);

        if (this.button && this.realButton) {
          this.button.addEventListener('click', () => this.realButton.click());
        }

        this.setupObserver();
        this.setupVariantListener();
      }

      // Show the bar once the real "Add to cart" button scrolls out of view,
      // hide it again once the customer scrolls back up to it.
      setupObserver() {
        const target =
          document.querySelector(`#ProductInfo-${this.sectionId} .product-form__buttons`) || this.realForm;

        if (!target || !('IntersectionObserver' in window)) {
          this.classList.add('is-visible');
          return;
        }

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.classList.toggle('is-visible', !entry.isIntersecting);
            });
          },
          { threshold: 0 }
        );
        observer.observe(target);
      }

      // Keep price / stock state in sync when the shopper picks a different variant.
      // Dawn already fetches a freshly-rendered copy of the section on every variant
      // change (window `variant-change` pub/sub event); we just borrow the already
      // correctly-formatted price markup from it instead of reformatting money client-side.
      setupVariantListener() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.sectionId) return;

          const variant = event.data.variant;
          const html = event.data.html;

          if (this.priceWrapper && html) {
            const sourcePrice = html.getElementById(`price-${this.sectionId}`);
            if (sourcePrice) this.priceWrapper.innerHTML = sourcePrice.innerHTML;
          }

          if (this.button) {
            const available = variant ? variant.available : false;
            this.button.disabled = !available;
            if (this.textEl && window.variantStrings) {
              this.textEl.textContent = available
                ? window.variantStrings.addToCart
                : window.variantStrings.soldOut;
            }
          }
        });
      }
    }
  );
}
